import { forwardRef, useMemo } from 'react';
import { Placement } from 'react-aria';
import Select, { BaseSelectProps, SelectOption } from '~/components/inputs/Select/Select';

export type SimpleSelectOption = Omit<SelectOption<string | null>, 'key'> & { key?: string };

interface Props extends BaseSelectProps {
  clearable?: boolean;
  emptyValue?: string;
  onChange: (value: string | null) => void;
  options: SimpleSelectOption[];
  value: string | null;
  listBoxPopoverPlacement?: Placement;
}

const SimpleSelect = forwardRef(
  ({ emptyValue, options, value, listBoxPopoverPlacement, ...baseProps }: Props, ref?: React.Ref<HTMLDivElement>) => {
    const o = useMemo(() => {
      return options.map((option) => ({ key: option.key ?? option.value ?? emptyValue ?? '', ...option }));
    }, [emptyValue, options]);

    return (
      <Select<string | null>
        {...baseProps}
        ref={ref}
        emptyValue={emptyValue}
        options={o}
        value={value === null ? (emptyValue ?? value) : value}
        listBoxPopoverPlacement={listBoxPopoverPlacement}
      />
    );
  },
);

export default SimpleSelect;
